var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "self-evaluation-test-styles" },
    [
      _c("loading-anim", {
        attrs: { active: _vm.$store.state.loading, fullScreen: "" }
      }),
      _vm._v(" "),
      _c("audio", {
        ref: "song",
        attrs: {
          id: "music",
          loop: "",
          src: "/static-appopensalud/audio/meditationSong.mp3"
        }
      }),
      _vm._v(" "),
      _vm.initialPage
        ? _c(
            "div",
            { staticClass: "test-container" },
            [
              _c("b-row", [_c("h2", [_vm._v(_vm._s(_vm.testName))]), _c("br")]),
              _vm._v(" "),
              _c("b-row", { staticClass: "mb-md-4 mb-sm-2 m-auto" }, [
                _c("p", {
                  domProps: {
                    innerHTML: _vm._s(
                      _vm.$t("tests." + _vm.testRoute + ".description")
                    )
                  }
                })
              ]),
              _vm._v(" "),
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    {
                      staticClass: "p-2 m-auto text-center",
                      attrs: { xs: "12", sm: "12", md: "6", lg: "6", xl: "6" }
                    },
                    [
                      _c(
                        "b-card",
                        { staticClass: "neu-card" },
                        [
                          _c("base-icon", {
                            staticClass: "d-block mb-3",
                            attrs: {
                              src:
                                "/static-appopensalud/img/icons/morillas-svg-icons/primary/pencil-icon-blue.svg",
                              height: _vm.iconSize,
                              width: _vm.iconSize,
                              color: _vm.BLUE_COLOUR
                            }
                          }),
                          _vm._v(" "),
                          _c("base-button", { on: { click: _vm.startTest } }, [
                            _c("span", [
                              _vm._v(
                                " " + _vm._s(_vm.$t("tests.startTest")) + " "
                              )
                            ])
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.canSeePastResults
                    ? _c(
                        "b-col",
                        {
                          staticClass: "p-2",
                          attrs: {
                            xs: "12",
                            sm: "12",
                            md: "6",
                            lg: "6",
                            xl: "6"
                          }
                        },
                        [
                          _c(
                            "b-card",
                            { staticClass: "neu-card" },
                            [
                              _c("base-icon", {
                                staticClass: "d-block mb-3",
                                attrs: {
                                  src:
                                    "/static-appopensalud/img/icons/morillas-svg-icons/primary/bars.svg",
                                  height: _vm.iconSize,
                                  width: _vm.iconSize,
                                  color: _vm.BLUE_COLOUR
                                }
                              }),
                              _vm._v(" "),
                              _c(
                                "base-button",
                                { on: { click: _vm.goToPastResults } },
                                [
                                  _c("span", [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.$t("tests.previousResults")
                                        ) +
                                        " "
                                    )
                                  ])
                                ]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c("transition", { attrs: { name: "fade", mode: "out-in" } }, [
        _vm.questionsPage
          ? _c(
              "div",
              { key: _vm.$store.state.tests.currentSlide },
              [
                _c(
                  "div",
                  { staticClass: "test-container" },
                  [
                    _c("div", { staticClass: "topDiv" }, [
                      _c("div", [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              parseInt(
                                (_vm.$store.state.tests.currentSlide * 100) /
                                  _vm.$store.state.tests.test.length
                              )
                            ) +
                              "% " +
                              _vm._s(_vm.$t("tests.completed"))
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "float-right" }, [
                        _c(
                          "button",
                          {
                            staticStyle: {
                              "background-color": "transparent",
                              border: "none"
                            },
                            on: { click: _vm.playPause }
                          },
                          [
                            _c("b-icon", {
                              attrs: {
                                icon: _vm.songPlaying
                                  ? "volume-up-fill"
                                  : "volume-mute-fill"
                              }
                            })
                          ],
                          1
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c("b-progress", {
                      staticClass: "testProgressBar",
                      staticStyle: { height: "0.2rem" },
                      attrs: {
                        value: _vm.$store.state.tests.currentSlide,
                        max: _vm.$store.state.tests.test.length
                      }
                    }),
                    _vm._v(" "),
                    _vm._t("questions")
                  ],
                  2
                ),
                _vm._v(" "),
                _c(
                  "transition",
                  { attrs: { name: "fade", appear: "" } },
                  [!_vm.resultsPage ? _c("wave-animation") : _vm._e()],
                  1
                )
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.goResultsPage
          ? _c(
              "div",
              { staticClass: "slidesSize" },
              [
                _c(
                  "b-col",
                  {
                    staticClass: "px-0 pt-1 px-md-5 pt-md-2 m-auto text-center",
                    attrs: { xs: "12", lg: "8" }
                  },
                  [
                    _c("h3", [
                      _c("strong", [
                        _vm._v(
                          _vm._s(_vm.$t("tests.congratulations")) +
                            " " +
                            _vm._s(_vm.$store.state.session.user.name)
                        )
                      ])
                    ]),
                    _c("br"),
                    _vm._v(" "),
                    _c("h4", {
                      domProps: {
                        innerHTML: _vm._s(_vm.$t("tests.testCompleted"))
                      }
                    }),
                    _c("br"),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-primary",
                        attrs: { type: "submit" },
                        on: { click: _vm.showResults }
                      },
                      [
                        _c("span", [
                          _vm._v(" " + _vm._s(_vm.$t("tests.finishTest")) + " ")
                        ])
                      ]
                    )
                  ]
                )
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.resultsPage
          ? _c(
              "div",
              { key: "results", staticClass: "test-container" },
              [_vm._t("results")],
              2
            )
          : _vm._e()
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-cc4bc35a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cc4bc35a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/selfEvaluationTests/TestTemplate.vue
// module id = 2503
// module chunks = 124 125 126 127 128 129 130 131 132 133 134 135 136 137 138